export default "/assets/standing-bed.75c610c8a0a20b328522131864d7cdcb.png";